import {Component, Input, ViewEncapsulation} from '@angular/core';
import {PortalLanguageObj} from 'mx-core';
import {Observable} from 'rxjs';
import {PrlLanguageService} from '../../services/prl-language.service';

@Component({
    selector: 'prl-language-picker',
    templateUrl: './prl-language-picker.component.html',
    styleUrls: ['./prl-language-picker.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class PrlLanguagePickerComponent {

    @Input() hoverColor: string;
    languages: Observable<Array<PortalLanguageObj>>;

    constructor(public languageService: PrlLanguageService) {
        this.languages = this.languageService.getPortalLanguages();
    }

    onLanguageChanged = (language: string) =>{
        this.languageService.setLanguage(language);
    };

    getHoverColor = (): string => {
        return this.hoverColor;
    };
}
